export default "__VITE_ASSET__C5Ru0BlQ__"